export enum StorageKeys {
  projectId = 'projectId',
  googleLoginAccessToken = 'googleLoginAccessToken',
  googleLoginExpireDate = 'googleLoginExpireDate',
  phsLastLoginType = 'phs-last-login-type',
  userToken = 'userToken',
}
